/**
 * elasticsearch模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const elasticsearch = {
  //分页
  pageElasticsearch(params) {
    return $http.post(`${global.API_URL}/sme/elasticsearch/page`,params);
  },
  //根据id查询es详情
  getEsDetailById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/elasticsearch/getEsDetailById`,param);
  },
  //根据账户和区域查询es列表
  listEsByAccount(params) {
    return $http.post(`${global.API_URL}/sme/elasticsearch/listEsByAccount`,params);
  },
  //删除
  deleteElasticsearch(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/elasticsearch/delete`,param);
  }
}

export default elasticsearch;



// WEBPACK FOOTER //
// ./src/api/elasticsearch.js